import { useParams, useNavigate } from "react-router";
import PageMeta from "../../components/common/PageMeta";
import PageBreadcrumb from "../../components/common/PageBreadCrumb";
import NewUpsellForm from "../../components/upsell/NewUpsellForm";

export default function NewUpsell() {
    const { productId } = useParams<{ productId: string }>();
    const navigate = useNavigate();

    // Função para voltar à página anterior
    const handleGoBack = () => {
        navigate(`/products/edit/${productId}?tab=upsell`);
    };

    return (
        <>
            <PageMeta
                title="Sellyo - Novo Upsell"
                description="Criar novo upsell para o produto"
            />
            <PageBreadcrumb
                pageTitle="Novo Upsell"
                showBackButton={true}
                onBack={handleGoBack}
            />

            <div className="container mx-auto px-4 md:px-6">
                <NewUpsellForm
                    productId={productId}
                    onSuccess={() => {
                        // Redirecionar para a página de edição do produto na aba de upsells
                        navigate(`/products/edit/${productId}?tab=upsell`);
                    }}
                    onError={(error) => {
                        console.error("Erro ao criar upsell:", error);
                    }}
                />
            </div>
        </>
    );
}